import styled from 'styled-components';
import { colors } from '../../theme/modules/colors';
import { BaseContainer } from '../BaseContainer';
export const Tag = styled(BaseContainer).withConfig({ displayName: "vui--Tag", componentId: "vui--1rdo7hk" }) `display:inline-flex;flex-direction:row;justify-content:center;align-items:center;border-radius:4px;padding:4px 8px;${({ backgroundColor, color }) => `
    color: ${color !== null && color !== void 0 ? color : colors.neutral.ink.base};
    background-color: ${backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : colors.neutral.grey.base};
  `}`;
//# sourceMappingURL=Tag.js.map